import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IWebRequestOptions } from 'src/app/shared/interfaces/web-request.interface';

import { CryptoVaultService } from '../../../external/crypto-vault/crypto-vault.service';
import { ICipherCommunicator } from './cipher-communicator.service';

@Injectable({
  providedIn: 'root',
})
export class CryptoVaultCipherCommunicatorService implements ICipherCommunicator {

  constructor(
    private cryptoVaultService: CryptoVaultService,
  ) {}

  encryptRequest(options: IWebRequestOptions): Promise<IWebRequestOptions> {
    const headers = options.headers;

    if (!headers) {
      return new Promise<IWebRequestOptions>(() => options);
    }

    const transactionId = headers.get('transaction_id');

    /*if(transactionId !== null){
      this.cryptoVaultService.keyExchange(transactionId);
    }*/

    return new Promise<IWebRequestOptions>(resolve => {
      this.cryptoVaultService.encrypt(JSON.stringify(options.body)).then(encryptedMessage => {
        options.body = {
          message: encryptedMessage,
        };

        resolve(options);
        return;
      });
    });
  }

  decryptResponse(encryptedResponse: HttpResponse<any>, options: IWebRequestOptions): Promise<HttpResponse<any>> {
    const headers = options.headers;

    if (!headers) {
      return new Promise<HttpResponse<any>>(() => encryptedResponse);
    }

    const transactionId = headers.get('transaction_id');

    return new Promise<HttpResponse<any>>(async resolve => {
      if (encryptedResponse.body.data.message) {
        resolve(encryptedResponse);
        return;
      }

      this.cryptoVaultService.decrypt(encryptedResponse.body.data.message).then(body => {
        const decryptedResponse = new HttpResponse<any>({
          status: 200,
          body: JSON.parse(body),
        });

        resolve(decryptedResponse);
      });
    });
  }
}
